/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileJpeg = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586v3.44h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M11.521 15.803c0 .392-.115.696-.345.912-.227.216-.545.323-.955.323-.166 0-.33-.018-.492-.054a1.383 1.383 0 0 1-.415-.151v-.738c.159.068.3.118.421.15.126.033.245.049.357.049.194 0 .34-.049.436-.146.101-.097.152-.237.152-.42v-1.986l-.718-.232v-.469h1.56zm9.284-2.838c.165 0 .33.014.49.043a2.3 2.3 0 0 1 .465.13v.712a3.307 3.307 0 0 0-.491-.119 2.508 2.508 0 0 0-.432-.038c-.414 0-.732.11-.955.33-.22.215-.33.527-.33.933 0 .453.096.793.287 1.02.194.222.489.334.885.334.15 0 .298-.009.442-.027l.054-.009v-.76l-.663-.218v-.453h1.45v1.926a3.155 3.155 0 0 1-.405.15 2.85 2.85 0 0 1-.436.087 3.288 3.288 0 0 1-.464.032c-.662 0-1.164-.176-1.506-.528-.338-.353-.507-.87-.507-1.554 0-.42.083-.78.248-1.074a1.66 1.66 0 0 1 .724-.68c.317-.158.698-.237 1.144-.237zm-7.175.076c.483 0 .846.111 1.09.334.249.223.373.554.373.993 0 .291-.056.536-.167.734a1.037 1.037 0 0 1-.491.442c-.216.1-.484.151-.804.151h-.566v1.268h-.836V13.04zm-.566 1.969h.394c.287 0 .49-.049.61-.146.122-.1.183-.266.183-.496 0-.234-.061-.4-.184-.497-.118-.097-.322-.145-.609-.145h-.394zm5.098-1.257h-1.71v.874h1.554v.712h-1.554v.912h1.765v.712H15.61V13.04h2.552z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileJpeg as FileJpeg };
